<template>
  <div class="text-xs">
    {{
      $t("SCORECARD_GROUPS.GPTS", {
        points: `${model.weighted_points} ⁄ ${model.group_points}`,
      })
    }}
  </div>
</template>

<script setup lang="ts">
import type { ScorecardForGroupTable } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ScorecardForGroupTable>,
    required: true,
  },
});
</script>
